<app-dark-back-button *ngIf="showBackButton$ | async" (backClicked)="goBack()" [paddingBottomRem]="2" />
<ng-container [ngSwitch]="authFlow$ | async">
  <!--  Sign In Flow  -->
  <ng-container *ngSwitchCase="MemberAuthFlow.SignIn">
    <app-sign-in (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Forgot Password Flow  -->
  <ng-container *ngSwitchCase="MemberAuthFlow.ForgotPassword">
    <app-forgot-password (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Reset Password Flow  -->
  <ng-container *ngSwitchCase="MemberAuthFlow.ResetPassword">
    <app-reset-password (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Member Welcome Flow  -->
  <ng-container *ngSwitchCase="MemberAuthFlow.MemberWelcome">
    <app-member-welcome />
  </ng-container>
  <!--  Member Setup Flow  -->
  <ng-container *ngSwitchCase="MemberAuthFlow.MemberSetup">
    <app-member-setup />
  </ng-container>
  <!--  Member Enter Email Verification Flow  -->
  <ng-container *ngSwitchCase="MemberAuthFlow.MemberEnterEmailVerification">
    <app-member-enter-email-verification />
  </ng-container>
  <!--  Member Send Email Verification Flow  -->
  <ng-container *ngSwitchCase="MemberAuthFlow.MemberSendEmailVerification">
    <app-member-send-email-verification (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Enter MFA Code Flow  -->
  <ng-container *ngSwitchCase="MemberAuthFlow.MemberMFAVerification">
    <app-verify-mfa (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Access Restricted  -->
  <ng-container *ngSwitchCase="MemberAuthFlow.MemberAccessRestricted">
    <app-mp-access-restricted />
  </ng-container>
</ng-container>
